// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MJ-x+","group":"styles_group__TY5th"};